module.exports = __webpack_public_path__ + "static/img/liyade1.7c3f25c9.jpg";